<template>
  <div class="journeys">
    <div class="journey-header">
      <span class="nav-icons">
        <a
          href=""
          @click.prevent="close"
          @keyup.enter="close"
          class="button exit"
        >
          <X></X>
        </a>
        <a
          href=""
          @click.prevent="openProfileMenu"
          @keyup.enter="openProfileMenu"
          class="button avatar"
        >
          <tooltip :text="$t('message.profile')">
            <img id="profile-menu-trigger" :src="currentUser.image" />
          </tooltip>
        </a>
      </span>
    </div>
    <div class="overview padding">
      <h2>{{ $t("message.learner-journeys") }}</h2>
      <span> {{ $t("message.learner-journeys-info") }} </span>
      <img
        src="@/assets/journeys-platform-spot-illustration.gif"
        :alt="$t('message.journeys-illo-alt')"
      />
    </div>
    <spinner v-if="loading"></spinner>
    <div class="list added" v-if="added.length">
      <h2 class="padding">{{ $t("message.your-learner-journeys") }}</h2>
      <div class="journey-grid">
        <JourneyTile
          class="journey-tile--added"
          :journey="journey"
          :showProgress="journey.started"
          v-for="journey in added"
        ></JourneyTile>
      </div>
      <a
        class="toggle-completed"
        href=""
        @click.prevent="toggleCompleted"
        @keyup.enter.prevent="toggleCompleted"
        v-if="hasCompletedJourneys"
      >
        {{ toggleCompletedText }}
      </a>
    </div>
    <div class="list others" v-if="others.length">
      <h2 class="padding">{{ $t("message.browse-learner-journeys") }}</h2>
      <div class="journey-grid">
        <JourneyTile :journey="journey" v-for="journey in others"></JourneyTile>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
@import "./shared.less";
.journeys {
  padding: 16px 20px 200px 20px;
  color: white;
  background: #212121;
  min-height: 100vh;
  width: 100%;
  top: 0px;
  position: absolute;
  .nav-icons {
    position: absolute;
    right: 36px;
    z-index: 3;
    .exit:hover {
      background: #666;
    }
    @media (max-width: 800px) {
      right: 10px;
    }
  }
  .padding {
    padding: 0px 25px;
  }
  .overview {
    width: 100%;
    margin-top: 50px;
    padding-bottom: 25px;
    position: relative;
    span {
      max-width: 400px;
      display: inline-block;
      margin-right: 80px;
      line-height: 145%;
      padding-top: 12px;
      position: relative;
      z-index: 1;
    }
    h2 {
      position: relative;
      z-index: 1;
    }
    img {
      height: auto;
      display: block;
      width: 100%;
      @media (min-width: 726px) {
        position: absolute;
        width: calc(100% - 205px);
        max-width: 620px;
      }

      @media (min-width: 1220px) {
        bottom: -50px;
        left: 545px;
      }

      @media (min-width: 726px) and (max-width: 1219px) {
        bottom: calc(92px - 100vw * 0.127);
        right: -20px;
      }

      @media (max-width: 725px) {
        width: 100%;
        margin: auto;
        margin-top: 30px;
      }
    }
    @media (max-width: 725px) {
      padding-bottom: 0px;
      margin-bottom: -100px;
    }
  }
  .list {
    margin-top: 50px;
    width: 100%;
    position: relative;
    z-index: 1;
    a {
      color: lightgray;
      text-decoration: underline;
    }
  }
  .journey-grid {
    display: flex;
    flex-wrap: wrap;
    padding: 15px;
  }
  @media all and (max-width: 725px) {
    .overview span {
      max-width: unset;
      margin-right: 10px;
    }
  }
  @media all and (max-width: 525px) {
    padding: 20px 0px 140px 0px;
    width: fit-content;
    .overview span {
      margin-right: 0px;
    }
  }
  .spinner::v-deep {
    margin: 60px 0 0 50%;
  }
}

.journey-tile--added {
  height: fit-content;
}

.toggle-completed {
  margin-left: 30px;
}
</style>

<script>
import JourneyTile from "@/journeys/JourneyTile";
import LayoutStandard from "@/layouts/standard";
import { mapGetters, mapState } from "vuex";
import X from "@/common/icons/X";
import Tooltip from "@/common/components/Tooltip";
export default {
  components: { LayoutStandard, JourneyTile, X, Tooltip },
  data() {
    return {
      showCompleted: false,
      loading: false,
    };
  },
  computed: {
    added() {
      if (!this.journeys) {
        return [];
      }
      if (this.showCompleted) {
        return this.journeys.filter((j) => j.added);
      }
      return this.journeys.filter((j) => j.added && !j.complete);
    },
    others() {
      if (!this.journeys) {
        return [];
      }
      return this.journeys.filter((j) => !j.added);
    },
    toggleCompletedText() {
      return this.showCompleted
        ? this.$t("message.hide-completed-journeys")
        : this.$t("message.show-completed-journeys");
    },
    hasCompletedJourneys() {
      return this.journeys.findIndex((j) => j.complete) >= 0;
    },
    ...mapState({
      journeys: (state) => state.journeys.journeys,
    }),
    ...mapGetters(["currentEdition", "currentUser"]),
  },
  mounted() {
    if (!this.journeys) {
      this.loading = true;
    }
    this.loadJourneys();
  },
  deactivated() {
    this.$store.commit("markJourneysAsViewed");
  },
  methods: {
    loadJourneys() {
      if (!this.journeys) {
        this.loading = true;
      }
      this.$store.dispatch("loadJourneys").then(() => (this.loading = false));
    },
    openProfileMenu() {
      this.$store.commit("setMenuOpen", "profile");
    },
    close() {
      this.$store.commit("markJourneysAsViewed");
      this.$store.commit("setShowJourneys", false);
    },
    toggleCompleted() {
      this.showCompleted = !this.showCompleted;
    },
  },
};
</script>
